<template>
   <bk-page class="myAddressPage" pageType="navPage" :navBarInfo="navBarInfo">
		<bk-view class="view-container">
			<bk-empty 
				:description="formData ? formData.addressText : $bk_lang['userInfo_myAddress_description']" 
				:image="oblissDZFlag ? 'Def_Empty_Address_healthyDZFlag.png' : 'Def_Empty_Address.png'"
			/>
			<bk-lang class="view-copywriting"  code="userInfo_myAddress_copywriting" />
		</bk-view>

		<bk-view class="view-footer-main">
			<bk-button v-if="formData" size="full" langCode="userInfo_myAddress_edit"  @click="setShowPage('updateAddress')"></bk-button>
			<bk-button v-else size="full" icon="icon-xianxingtubiaozhizuomoban-03" langCode="userInfo_myAddress_add" @click="setShowPage('updateAddress')"></bk-button>
		</bk-view>

		<transition name="rightFadeIn">
      <component :is="showPage" :curRows="formData"  @close="setShowPage()" @reload="initData" />
    </transition>
	</bk-page>
</template>

<script>
	import { authReq } from '@/reqService';
	import updateAddress from '../updateAddress/updateAddress.vue';
	
	export default {
		name:'myAddress',
		components:{ updateAddress },
		data (){
			return {
				navBarInfo: {
					langCode_title:'userInfo_myAddress_title',
					backFlag: true,
				},
				showPage:'',
				userInfo:this.$bk_getUserInfo(),
				formData:null,
				oblissDZFlag:window.oblissDZFlag,
			};
		},
		mounted (){
			this.initData();
		},
		methods:{
			setShowPage (showPage=''){
				this.showPage = showPage;
			},
			initData (){
				this.requestGetUserAddress();
			},
			async requestGetUserAddress (){
				let res = await authReq.requestGetUserAddress(this, {id:this.userInfo.id});

				if(res.length){
					res = res[0];
					const { countryName='', provinceName='', cityName='', address='', } = res;
					res.addressText = `${countryName}${provinceName}${cityName}${address}`;
					this.formData = res;
				}
			
			}
		}
	};
</script>

<style lang="less">
@import './myAddress.less';
</style>